
import React, { useState } from 'react';
import { themeSelector } from '../../design/theme';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import {
    Button,
    Card,
    CardContent,
    Typography,
    TextField
} from '@material-ui/core';
import ReCAPTCHA from "react-google-recaptcha";
import { ArrowForwardIos, MailOutlineOutlined } from '@material-ui/icons'
import { RecaptchaAPI, SignUpAPI } from '../../lib/api';
import config from '../../lib/config';
import { validateEmail } from 'views/Components/Form';

const API = {
    recaptcha: new RecaptchaAPI(),
    signUp: new SignUpAPI()
}
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        width: '100%',
        flexGrow: 1,
        flexFlow: 'column',

    },
    container: {
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
        flexFlow: 'column'
    },
    img: {
        width: '100%',
        minWidth: '200px',
        maxWidth: '300px',
        marginLeft: "auto",
        marginRight: 'auto',
        display: "block"
    },
    card: {
        border: 0,
        borderRadius: '6px 6px 0px 0px',
        width: "300px"
    },
    button: {
        width: '100%',
        borderRadius: '0px 0px 6px 6px',
        height: '70px',
        color: 'white',
        backgroundColor: '#417fb4',
        transitionDuration: '1s',
        transitionProperty: 'font-size'
    },
    textField: {
        [`& .MuiInput-root`]: {
            borderRadius: '0px 3px 3px 0px',
            padding: 0
        },
        [`& input`]: {
            paddingLeft: '10px'
        },
        [`& .MuiInputBase-root`]: {
            borderRadius: '0p 3p 3px 0px',
            borderColor: '#f1f1f1',
            "&.Mui-focused": {
                borderColor: "#a1a1a1"
            },
            "&.Mui-error": {
                borderColor: "red"
            },
        },
    }
}));

const theme = themeSelector('default');
function SignUpView(props) {
    const recaptchaRef = React.useRef();
    const classes = useStyles();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [isResponseSuccessful, setResponse] = useState(false);

    const handleChange = (event) => {
        const email = event.target.value
        if (validateEmail(event.target.value)) {
            setError('');
        }
        setEmail(email);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
       
        if (email === '' || !validateEmail(email)) {
            setError('Email is not valid');
            return;
        }
        try {
            const recaptchaToken = await recaptchaRef.current.executeAsync();
            const signUpResponse = await API.signUp.create({
                email,
                first_name: '',
                last_name: '',
                org_roles: [],
                locations: [],
                recaptcha_token: recaptchaToken
            });

            setResponse(signUpResponse.success);

        }
        catch (e) {
            recaptchaRef.current.reset();
            setError(e.toString());
            setEmail('');
        }

    }

    return (
         <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* <div className={classes.root}> */}
                <Container maxWidth="xs" className={classes.container}>
                    <div style={{ textAlign: 'center' }}>
                        {isResponseSuccessful && <>
                            <Typography
                                style={{
                                    marginTop: 10,
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    whiteSpace: 'pre-line',
                                }}
                            >
                                We sent you an email!
                            </Typography>
                            <Typography
                                style={{
                                    marginTop: 10,
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                    whiteSpace: 'pre-line',
                                }}
                            >
                                Please check your email to finish setting  <br /> up your Blumira account.
                            </Typography>
                        </>
                        }
                        {!isResponseSuccessful &&
                            <>
                               
                                <form onSubmit={handleSubmit}>
                                    <Card variant="outlined" className={classes.card}>
                                        <CardContent style={{ display: "flex", flexFlow: "column" }}>
                                            <Typography variant="caption" align="center">
                                                Please enter your email address. We will<br/> send you an email to set your<br/> password.
                                            </Typography>
                                          
                                            <br />
                                            <TextField className={classes.textField}
                                                placeholder="csmith@acmeorg.com"
                                                error={error!==''}
                                                InputProps={{
                                                    startAdornment: (
                                                        <div style={{ display: "flex", alignItems: 'center', backgroundColor: '#f1f1f1', padding: '10px' }}>
                                                            <MailOutlineOutlined fontSize="small" color="primary" />
                                                        </div>
                                                    ),
                                                }}
                                                type='text'
                                                onChange={handleChange}
                                                value={email}
                                            />
                                            {error &&
                                                <Typography variant='caption' align='center' color="error">
                                                    {error}
                                                </Typography>
                                            }

                                        </CardContent>

                                    </Card>
                                    <Button variant="contained" type='submit' disableElevation className={classes.button} endIcon={<ArrowForwardIos />}>
                                        SEND EMAIL
                                    </Button>
                                </form>
                            </>
                        }
                    </div>
                    <br />
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        size="invisible"
                        sitekey={config.recaptcha_site_key}
                    />
                </Container>

            {/* </div> */}

        </ThemeProvider>
    )
}

export default SignUpView;